import { PHSearchInput } from "./PHSearchInput"

export { PHSearchInput }
export default PHSearchInput
